import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../../api/supabase';
import { useAuth } from '../../context/AuthContext';

export default function SupplierForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const isEdit = !!id;
  const [form, setForm] = useState({
    name: '', contact_person: '', email: '', phone: '', address: '',
    country: '', supplier_type: 'Hotel', payment_terms: '', notes: '', is_active: true
  });
  const [accounts, setAccounts] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    supabase.from('chart_of_accounts').select('id, account_code, account_name').order('account_code').then(({ data }) => setAccounts(data || []));
    if (isEdit) supabase.from('suppliers').select('*').eq('id', id).single().then(({ data }) => { if (data) setForm(data); });
  }, [id, isEdit]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    if (!form.name) { setError('Supplier name is required'); return; }
    setSaving(true); setError('');
    try {
      const username = user?.email?.split('@')[0] || 'unknown';
      if (isEdit) {
        await supabase.from('suppliers').update({ ...form, updated_by: username, updated_at: new Date().toISOString() }).eq('id', id);
        navigate(`/suppliers/${id}`);
      } else {
        const code = 'SUP' + Date.now().toString().slice(-5);
        const { data, error: err } = await supabase.from('suppliers').insert({ ...form, supplier_code: code, created_by: username }).select().single();
        if (err) throw err;
        navigate(`/suppliers/${data.id}`);
      }
    } catch (err) { setError(err.message || 'Error saving'); setSaving(false); }
  };

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">{isEdit ? 'Edit Supplier' : 'New Supplier'}</div></div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>{saving ? 'Saving...' : 'Save Supplier'}</button>
        </div>
      </div>
      {error && <div style={{ color: 'var(--danger)', marginBottom: 16 }}>{error}</div>}
      <div className="card">
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Supplier Name *</label>
            <input className="form-input" value={form.name} onChange={e => set('name', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Type</label>
            <select className="form-input" value={form.supplier_type} onChange={e => set('supplier_type', e.target.value)}>
              {['Hotel', 'Airline', 'Visa Agent', 'Land Operator', 'Insurance', 'Other'].map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Contact Person</label>
            <input className="form-input" value={form.contact_person || ''} onChange={e => set('contact_person', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" value={form.email || ''} onChange={e => set('email', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Phone</label>
            <input className="form-input" value={form.phone || ''} onChange={e => set('phone', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Country</label>
            <input className="form-input" value={form.country || ''} onChange={e => set('country', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Payment Terms</label>
            <input className="form-input" value={form.payment_terms || ''} onChange={e => set('payment_terms', e.target.value)} placeholder="e.g. Net 30, Advance" />
          </div>
          <div className="form-group">
            <label className="form-label">Linked COA Account</label>
            <select className="form-input" value={form.account_id || ''} onChange={e => set('account_id', e.target.value)}>
              <option value="">-- Select account --</option>
              {accounts.map(a => <option key={a.id} value={a.id}>{a.account_code}  {a.account_name}</option>)}
            </select>
          </div>
          <div className="form-group full-width">
            <label className="form-label">Address</label>
            <input className="form-input" value={form.address || ''} onChange={e => set('address', e.target.value)} />
          </div>
          <div className="form-group full-width">
            <label className="form-label">Notes</label>
            <textarea className="form-textarea" value={form.notes || ''} onChange={e => set('notes', e.target.value)} />
          </div>
          {isEdit && (
            <div className="form-group">
              <label className="form-label">Status</label>
              <select className="form-input" value={form.is_active ? 'true' : 'false'} onChange={e => set('is_active', e.target.value === 'true')}>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
